export const USER_KEY = 'username';
export const PROFILE_KEY = 'profiles'
export const LANGUAGE_KEY = 'language'
export const STICKER_KEY = 'stickers';
export const RECENT_STICKER_KEY = 'stickerRecent';